(function () {
  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('oddit-team-modal-open');
    var closeBtn = modal.querySelector('[data-team-modal-close]');
    if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    if (!document.querySelector('.oddit-section-meet-the-team__modal:not([hidden])')) {
      document.body.classList.remove('oddit-team-modal-open');
    }
  }

  function initCarousel(carousel) {
    if (carousel.dataset.odditTeamCarouselWired === '1') return;
    carousel.dataset.odditTeamCarouselWired = '1';

    var grid = carousel.querySelector('[data-team-grid]');
    var prevBtn = carousel.querySelector('[data-team-scroll-prev]');
    var nextBtn = carousel.querySelector('[data-team-scroll-next]');
    var dotsContainer = carousel.querySelector('[data-team-dots]');
    if (!grid) return;

    function getCardStep() {
      var cards = grid.querySelectorAll('.oddit-section-meet-the-team__card');
      if (cards.length < 2) return cards.length ? cards[0].offsetWidth : 0;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }

    function getCardsPerPage() {
      var step = getCardStep();
      if (!step) return 1;
      return Math.max(1, Math.floor(grid.clientWidth / step));
    }

    function getMaxScroll() {
      return Math.max(0, grid.scrollWidth - grid.clientWidth);
    }

    function updateArrows() {
      var max = getMaxScroll();
      var overflowing = max > 4;
      if (prevBtn) prevBtn.hidden = !overflowing || grid.scrollLeft <= 4;
      if (nextBtn) nextBtn.hidden = !overflowing || grid.scrollLeft >= max - 4;
    }

    function rebuildDots() {
      if (!dotsContainer) return;
      var cards = grid.querySelectorAll('.oddit-section-meet-the-team__card');
      var perPage = getCardsPerPage();
      var maxScroll = getMaxScroll();
      // One dot per "stop" — i.e. positions where the first visible card can land.
      // With per-card stepping, that's (cards.length - perPage + 1) stops.
      var stopCount = Math.max(1, cards.length - perPage + 1);
      if (maxScroll <= 4 || stopCount <= 1) {
        dotsContainer.innerHTML = '';
        return;
      }
      var step = getCardStep();
      var html = '';
      for (var i = 0; i < stopCount; i++) {
        html += '<button type="button" class="oddit-section-meet-the-team__dot" data-team-dot-index="' + i + '" aria-label="Go to position ' + (i + 1) + '"></button>';
      }
      dotsContainer.innerHTML = html;
      var dots = dotsContainer.querySelectorAll('.oddit-section-meet-the-team__dot');
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-team-dot-index'), 10);
          if (isNaN(idx) || !step) return;
          grid.scrollTo({ left: idx * step, behavior: 'smooth' });
        });
      });
      updateActiveDot();
    }

    function updateActiveDot() {
      if (!dotsContainer) return;
      var dots = dotsContainer.querySelectorAll('.oddit-section-meet-the-team__dot');
      if (!dots.length) return;
      var step = getCardStep();
      if (!step) return;
      var idx = Math.round(grid.scrollLeft / step);
      var clamped = Math.min(Math.max(idx, 0), dots.length - 1);
      dots.forEach(function (d, i) {
        d.classList.toggle('oddit-section-meet-the-team__dot--active', i === clamped);
      });
    }

    function scrollByCard(direction) {
      var step = getCardStep();
      if (!step) return;
      var currentIdx = Math.round(grid.scrollLeft / step);
      var targetIdx = currentIdx + direction;
      grid.scrollTo({ left: targetIdx * step, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    var scrollDebounce;
    grid.addEventListener('scroll', function () {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(function () {
        updateArrows();
        updateActiveDot();
      }, 80);
    }, { passive: true });

    var resizeDebounce;
    window.addEventListener('resize', function () {
      clearTimeout(resizeDebounce);
      resizeDebounce = setTimeout(function () {
        rebuildDots();
        updateArrows();
      }, 120);
    });

    rebuildDots();
    updateArrows();
  }

  function init(scope) {
    var root = scope || document;
    var openers = root.querySelectorAll('[data-team-modal-open]');
    openers.forEach(function (btn) {
      if (btn.dataset.odditTeamWired === '1') return;
      btn.dataset.odditTeamWired = '1';
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-team-modal-open');
        var modal = document.querySelector('[data-team-modal="' + key + '"]');
        openModal(modal);
      });
    });

    var closers = root.querySelectorAll('[data-team-modal-close]');
    closers.forEach(function (el) {
      if (el.dataset.odditTeamCloseWired === '1') return;
      el.dataset.odditTeamCloseWired = '1';
      el.addEventListener('click', function () {
        var modal = el.closest('.oddit-section-meet-the-team__modal');
        closeModal(modal);
      });
    });

    var carousels = root.querySelectorAll('[data-team-carousel]');
    carousels.forEach(initCarousel);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openModalEl = document.querySelector('.oddit-section-meet-the-team__modal:not([hidden])');
    if (openModalEl) closeModal(openModalEl);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
